import { Link } from 'react-router-dom';

const articles = [
  {
    slug: '/article/best-cssbuy-spreadsheet-guide-2026',
    title: 'Best CSSBuy Spreadsheet Guide 2026: Ultimate Proxy Shopping Resource',
    excerpt: 'Everything you need to know about finding and using the best CSSBuy spreadsheet for proxy shopping. Updated weekly with verified sellers and insider tips.',
    date: 'July 5, 2026',
    tag: 'Guide',
    image: 'https://readdy.ai/api/search-image?query=Overhead%20desk%20scene%20with%20open%20laptop%20displaying%20analytics%20dashboard%20beside%20a%20handwritten%20notebook%20with%20colorful%20sticky%20notes%2C%20warm%20ceramic%20mug%20with%20steam%20rising%2C%20scattered%20pens%20and%20reading%20glasses%20on%20light%20oak%20wood%20surface%2C%20soft%20morning%20light%20with%20gentle%20shadows%2C%20organized%20creative%20workspace%20aesthetic%20with%20cozy%20productive%20atmosphere&width=800&height=560&seq=article-card-v3-1&orientation=landscape',
  },
  {
    slug: '/article/kakobuy-vs-cssbuy-spreadsheet-comparison',
    title: 'Kakobuy vs CSSBuy Spreadsheet: Which Agent Wins in 2026?',
    excerpt: 'A detailed head-to-head comparison of spreadsheet quality, shipping speed, pricing, and more between Kakobuy and CSSBuy.',
    date: 'July 6, 2026',
    tag: 'Comparison',
    image: 'https://readdy.ai/api/search-image?query=Two%20smartphones%20displaying%20comparison%20charts%20on%20clean%20white%20desk%20surface%2C%20side%20by%20side%20product%20photography%20approach%2C%20warm%20morning%20sunlight%20from%20window%2C%20minimal%20modern%20workspace%20with%20small%20green%20succulent%20plant%2C%20neutral%20cream%20and%20cool%20grey%20tones%2C%20clean%20tech%20lifestyle%20composition&width=800&height=560&seq=article-card-v3-2&orientation=landscape',
  },
  {
    slug: '/article/superbuy-spreadsheet-premium-guide',
    title: 'Superbuy Premium Spreadsheet Guide: High-End Proxy Shopping Playbook',
    excerpt: 'Master the Superbuy spreadsheet for premium finds. Curated sellers, faster shipping, and VIP support explained in detail.',
    date: 'July 6, 2026',
    tag: 'Guide',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20leather%20bound%20notebook%20open%20on%20rich%20dark%20walnut%20desk%20surface%2C%20elegant%20gold%20pen%20catching%20light%2C%20reading%20glasses%20resting%20nearby%2C%20warm%20ambient%20glow%20from%20brass%20desk%20lamp%2C%20sophisticated%20executive%20workspace%2C%20deep%20charcoal%20and%20cognac%20brown%20tones%2C%20premium%20editorial%20photography&width=800&height=560&seq=article-card-v3-3&orientation=landscape',
  },
  {
    slug: '#',
    title: 'Coming Soon: Oopbuy Budget Spreadsheet List',
    excerpt: 'Discover the most affordable proxy shopping spreadsheets on Oopbuy for budget-conscious shoppers.',
    date: 'Coming Soon',
    tag: 'Preview',
    image: 'https://readdy.ai/api/search-image?query=Simple%20minimal%20desk%20with%20printed%20spreadsheet%20pages%20and%20steaming%20coffee%20mug%20on%20light%20maple%20wood%20surface%2C%20natural%20daylight%20from%20nearby%20window%20creating%20soft%20highlights%2C%20budget%20friendly%20organized%20workspace%2C%20warm%20cream%20and%20light%20beige%20tones%2C%20clean%20approachable%20photography%20style&width=800&height=560&seq=article-card-v3-4&orientation=landscape',
  },
];

export default function ArticlePreview() {
  return (
    <section id="guides" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-10 md:mb-14 gap-4">
          <div>
            <div className="flex items-center gap-3 mb-3">
              <span className="w-8 h-[2px] bg-accent-500"></span>
              <span className="text-xs font-semibold text-accent-600 uppercase tracking-wider font-label">Latest Guides</span>
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight tracking-tight">
              CSSBuy Spreadsheet Guides
            </h2>
          </div>
          <Link
            to="/article/best-cssbuy-spreadsheet-guide-2026"
            className="text-sm text-accent-600 hover:text-accent-700 font-medium whitespace-nowrap font-label flex items-center gap-1"
          >
            View All Guides
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {articles.map((article, idx) => (
            <article key={idx} className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-background-300/60 transition-all duration-300">
              {article.slug !== '#' ? (
                <Link to={article.slug} className="block cursor-pointer">
                  <div className="relative overflow-hidden aspect-[4/3]">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute top-3 right-3">
                      <span className={`text-[10px] font-semibold uppercase tracking-wider px-2.5 py-1 rounded-full font-label ${
                        article.tag === 'Guide' ? 'bg-accent-500 text-background-50' :
                        article.tag === 'Comparison' ? 'bg-secondary-500 text-background-50' :
                        'bg-background-200/80 text-foreground-600'
                      }`}>
                        {article.tag}
                      </span>
                    </div>
                  </div>
                  <div className="p-5">
                    <span className="text-[11px] text-foreground-500 font-body">{article.date}</span>
                    <h3 className="font-heading text-sm font-semibold text-foreground-950 mt-2 mb-1.5 leading-snug line-clamp-2">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2 font-body">
                      {article.excerpt}
                    </p>
                    <div className="mt-3 flex items-center gap-1 text-xs text-accent-600 font-medium font-label">
                      <span>Read More</span>
                      <i className="ri-arrow-right-line text-[10px]"></i>
                    </div>
                  </div>
                </Link>
              ) : (
                <div className="block cursor-default">
                  <div className="relative overflow-hidden aspect-[4/3]">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute top-3 right-3">
                      <span className="text-[10px] font-semibold uppercase tracking-wider px-2.5 py-1 rounded-full font-label bg-background-200/80 text-foreground-600">
                        {article.tag}
                      </span>
                    </div>
                  </div>
                  <div className="p-5">
                    <span className="text-[11px] text-foreground-500 font-body">{article.date}</span>
                    <h3 className="font-heading text-sm font-semibold text-foreground-950 mt-2 mb-1.5 leading-snug line-clamp-2">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2 font-body">
                      {article.excerpt}
                    </p>
                    <div className="mt-3 flex items-center gap-1 text-xs text-foreground-400 font-label">
                      <span>Coming Soon</span>
                      <i className="ri-time-line text-[10px]"></i>
                    </div>
                  </div>
                </div>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}